module.exports = __webpack_public_path__ + "8e229a03.woff2";